module.exports = __webpack_public_path__ + "img/addres_bg.ed977e43.png";